import { cn } from '@brew/ui/cn'
import type { ReactNode } from 'react'
import {
  MARKETING_GUTTER_X,
  type MarketingContainerSize,
  marketingContainerMaxWidth,
} from './marketing-layout'

export type MarketingContainerProps = {
  children: ReactNode
  /**
   * - `wide` / `default` → max-w-7xl (most marketing sections)
   * - `narrow` → max-w-5xl (blog index, editorial divider)
   * - `prose` → max-w-3xl (articles, final CTA copy column)
   */
  size?: MarketingContainerSize
  className?: string
  /** When true, applies horizontal gutters inside the container. Default false. Sections own gutters on the outer `<section>`. */
  withGutters?: boolean
}

/**
 * Single alignment column for marketing content. Sections typically apply
 * `MARKETING_GUTTER_X` on the outer `<section>` and render this inside
 * without `withGutters`.
 */
export function MarketingContainer({
  children,
  size = 'default',
  className,
  withGutters = false,
}: MarketingContainerProps) {
  return (
    <div
      className={cn(
        marketingContainerMaxWidth(size),
        { [MARKETING_GUTTER_X]: withGutters },
        className
      )}
    >
      {children}
    </div>
  )
}
